import {HttpEvent, HttpInterceptorFn} from '@angular/common/http';
import {Observable} from 'rxjs';
import {inject} from '@angular/core';
import {EnvironmentService} from '../services/environment.service';

export const baseInterceptor: HttpInterceptorFn = (request, next): Observable<HttpEvent<any>> => {
  const config = inject(EnvironmentService);

  if (!config.baseUrl) {
    return next(request);
  }

  request = request.clone({
    url: `${config.baseUrl}${request.url}`,
  });

  return next(request);
}
